//@flow

import React from "react"
import { TweenMax, Cubic } from "gsap"
import { FormattedMessage } from "react-intl"
import {
  ForecastProgressBar,
  ForecastProgressBarContainer,
  CurrentProgressItem,
  PastProgressItem
} from "../UI"

import MetricLabel from "./MetricLabel"

import type { Direction } from "../types"
import type { Level, Metric } from "../../Shared/AQILegend"

type Props = {
  level: Level,
  direction: Direction,
  pollutant: Metric,
  readings: number[],
  delay: number
}

const offsetForDirection = (direction: Direction): number => {
  switch (direction) {
    case "increasing":
      return 20
    case "decreasing":
      return -20
    default:
      return 0
  }
}

const renderValue = (value: number): string => (value >= 0 ? `${value}` : "?")

class ForecastProgress extends React.Component<Props> {
  container: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.container = null
  }

  componentDidMount() {
    const { direction, delay } = this.props
    const offset = offsetForDirection(direction)
    TweenMax.set(this.container, { y: `+=${offset}`, opacity: 0 })
    TweenMax.to(this.container, 0.5, {
      y: "0",
      opacity: 1,
      ease: Cubic.easeOut,
      delay
    })
  }

  render() {
    const { level, direction, pollutant, readings } = this.props
    const [current, ...past] = readings
    const currentRenderableValue =
      current > 0 ? current : past.filter(val => val > 0)[0]
    return (
      <ForecastProgressBarContainer innerRef={el => (this.container = el)}>
        <ForecastProgressBar level={level} direction={direction}>
          <CurrentProgressItem>
            {currentRenderableValue >= 0 ? (
              renderValue(currentRenderableValue)
            ) : (
              <FormattedMessage id="kiosk.forecast.level.nodata" />
            )}{" "}
            {current > 0 ? <MetricLabel metric={pollutant} /> : ""}
          </CurrentProgressItem>
          {past.map((value, index) => (
            <PastProgressItem key={`past${index}`}>
              {renderValue(value)}
            </PastProgressItem>
          ))}
        </ForecastProgressBar>
      </ForecastProgressBarContainer>
    )
  }
}

export default ForecastProgress



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/ForecastProgress.js